/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Required

1 = Pending

2 = Approved

3 = Declined


 */
export type OptionMode = (typeof OptionMode)[keyof typeof OptionMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptionMode = {
  Required: 0,
  Pending: 1,
  Approved: 2,
  Declined: 3,
} as const;
